import moment from 'moment';
import { useStyles } from './styles';
import { clamp, padStart } from 'lodash';
import { ChangeEvent, FocusEvent, useEffect, useState } from 'react';

const formatTime = (timeMs: number) => {
  const t = moment.duration(timeMs);
  return {
    hours: t.hours(),
    minutes: t.minutes(),
    seconds: t.seconds(),
    milliseconds: t.milliseconds(),
  };
};
const toMs = ({
  hours,
  minutes,
  seconds,
  milliseconds,
}: ReturnType<typeof formatTime>) =>
  hours * 3_600_000 + minutes * 60_000 + seconds * 1_000 + milliseconds;

const TimeInput = ({ value, label, textHelper, onChange }: TimeInputProps) => {
  const classes = useStyles();
  const [time, setTime] = useState<Time>(formatTime(value));

  useEffect(() => {
    setTime(formatTime(value));
  }, [value]);

  const onChangeLocal =
    (name: string, min: number, max: number) =>
    (evt: ChangeEvent<HTMLInputElement>) => {
      const val = clamp(parseInt(evt.target.value, 10) || 0, min, max);
      const newTime = { ...time, [name]: val };
      setTime(newTime);
      onChange(toMs(newTime));
    };

  const onFocus = (evt: FocusEvent<HTMLInputElement>) => {
    evt.target.select();
  };

  return (
    <>
      <div
        className={classes.timeInputTitle}
        data-testid="timeline-range-editor-popup-time-input-title"
      >
        {label}
        <span className={classes.timeInputTextHelper}>{textHelper}</span>
      </div>
      <div
        className={classes.groupInput}
        data-testid="timeline-range-editor-popup-group-input"
      >
        <input
          data-testid="timeline-range-editor-popup-input"
          type="text"
          value={padStart(String(time.hours), 2, '0')}
          onChange={onChangeLocal('hours', 0, time.hours)}
          onFocus={onFocus}
        />
        <span className={classes.timeSpacer}>{':'}</span>
        <input
          data-testid="timeline-range-editor-popup-input"
          type="text"
          value={padStart(String(time.minutes), 2, '0')}
          onChange={onChangeLocal('minutes', 0, 59)}
          onFocus={onFocus}
        />
        <span className={classes.timeSpacer}>{':'}</span>
        <input
          data-testid="timeline-range-editor-popup-input"
          type="text"
          value={padStart(String(time.seconds), 2, '0')}
          onChange={onChangeLocal('seconds', 0, 59)}
          onFocus={onFocus}
        />
        <span className={classes.timeSpacer}>{'.'}</span>
        <input
          data-testid="timeline-range-editor-popup-input"
          type="text"
          value={padStart(String(time.milliseconds), 3, '0')}
          onChange={onChangeLocal('milliseconds', 0, 999)}
          onFocus={onFocus}
        />
      </div>
    </>
  );
};

interface Time {
  hours: number;
  minutes: number;
  seconds: number;
  milliseconds: number;
}

export interface TimeInputProps {
  value: number;
  label: string;
  textHelper: string;
  onChange: (timeMs: number) => void;
}

export default TimeInput;
